import { render, staticRenderFns } from "./ProductTypeCreate.vue?vue&type=template&id=b4b3f6fc&"
import script from "./ProductTypeCreate.vue?vue&type=script&lang=js&"
export * from "./ProductTypeCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports